var activityTypes = [
    { label: "Water",   value: 1,unit:'Glasses' },
    { label: "Running", value: 2,unit:'Km' },
    { label: "Cycling", value: 3,unit:'Km' },
    { label: "Diet", value: 4,unit:'-' },
  ]

module.exports = {
    activityTypes
}